<template>
  <div class="experiment" v-if="loading">
    <div class="experimentListDetail-top">
      <img :src="experimentDetail.cover" class="logo" alt="" :style="$route.path == '/myExperiment'
        ? 'cursor: pointer;'
        : 'cursor: default;'
        " @click="goExperimentDetail" />
      <div class="experimentListDetail-top-title">
        <h3>
          <span>{{ experimentDetail.name }}</span>
        </h3>
        <h4>
          <span>{{ experimentDetail.collegeName }} &nbsp;&nbsp;|&nbsp;&nbsp;
            {{ experimentDetail.tagName }}</span>
        </h4>
        <div class="isOpen">
          <div class="open" v-if="experimentDetail.shelvesStatus == 1">
            公开
          </div>
          <span>{{ experimentDetail.classHour }}课时</span>
        </div>
        <div class="logo-list">
          <div class="list">
            <img src="@/assets/images/common/eye.png" alt="" /><span>{{
              experimentDetail.scanNum
            }}</span>
          </div>
          <div class="line"></div>
          <div class="list">
            <img src="@/assets/images/common/participate.png" alt="" /><span>{{
              experimentDetail.upNum
            }}</span>
          </div>
          <div class="line"></div>
          <div class="list" style="cursor: pointer">
            <img src="@/assets/images/common/collection.png" alt="" v-if="!isCollection" />
            <img src="@/assets/images/common/collection-active.png" alt="" v-else />
            <span>{{ experimentDetail.favoriteNum }}</span>
          </div>
        </div>
        <!-- <div class="startExperiment" v-if="isRoles != 1"> -->
        <div class="startExperiment">
          <div class="btn1" @click="play()">开始实验</div>
          <div class="btn2" @click="queryScore" v-if="!(isRoles == 1)">
            查看成绩
          </div>
          <div class="btn3" @click="quitSelfStudy" v-if="isRoles == 2 && experimentDetail.obligatory == 2">
            退出选课
          </div>
          <div class="btn4" @click="Collection" v-if="!(isRoles == 1)">
            <template v-if="isCollection">取消收藏</template>
            <template v-else>收藏</template>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="查看实验记录" :visible.sync="dialogTableVisible">
      <el-table :data="scoreList">
        <!-- <el-table-column property="id" label="序号"> </el-table-column> -->
        <el-table-column label="最近实验时间">
          <template slot-scope="scope">
            {{ getTime(scope.row.startDate) }}
          </template>
        </el-table-column>
        <el-table-column property="date" label="提交时间">
          <template slot-scope="scope">
            {{ getTime(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column property="score" label="总成绩"> </el-table-column>
        <!-- <el-table-column property="date" label="是否有报告">
          <template slot-scope="scope">
            <span v-if="scope.row.report == ''">否</span>
            <span v-else>是</span>
          </template>
        </el-table-column> -->
        <!-- 暂时没有 -->
        <el-table-column width="200">
          <template slot="header">
            <span class="fontSizeCenter">操作</span>
          </template>
          <template slot-scope="scope">
            <p class="operation">
              <span @click="previewPeport(scope.row)">预览</span><i>|</i><span
                @click="downloadReport(scope.row)">下载报告</span>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <template v-if="showDialog && pdfUrl">
      <report-dialog v-model="showDialog" :pdfUrl="pdfUrl"></report-dialog>
    </template>
  </div>
</template>

<script>
import util from "@/assets/util/util.js";
import ReportDialog from "@/components/dialog/report-dialog.vue";
export default {
  name: "VirtualimitationExperiment",
  components: {
    ReportDialog,
  },
  props: {
    id: {
      type: [String, Number],
    },
    isMyExperiment: {
      //2必修 3选修 4收藏
      type: [String, Number],
      default: 0, //0是全部
    },
  },
  data () {
    return {
      isCollection: false, //是否收藏
      isRoles: -1, //当前角色
      isPlay: false,
      experimentDetail: null,
      loading: false,
      num: 0, //只运行一次
      scoreList: [],
      dialogTableVisible: false,
      userInfo: null,
      showDialog: false,
      pdfUrl: null,
      currentRole: 1,
    };
  },

  mounted () {
    this.userInfo = JSON.parse(localStorage.getItem("USER"));
    if (this.userInfo) {
      if (!this.userInfo.type) {
        this.userInfo.type = 5; //普通用户由于没有type属性，但是需要查看到成绩，所以赋值一个默认值5
      }
      this.isRoles = this.userInfo.type; //普通用户是没有type属性的
      this.currentRole = localStorage.getItem("type")
      console.log(this.currentRole);
    }

    this.getExperimentInfo();
  },

  methods: {
    //预览
    previewPeport (row) {
      if (!row.url) {
        this.$message.warning("暂无报告");
        return;
      }
      this.pdfUrl = row.url;
      this.showDialog = true;
    },
    //下载报告
    downloadReport (row) {
      if (!row.url) {
        this.$message.warning("暂无报告");
        return;
      }
      let title = `${this.experimentDetail.name}-${row.convertedCreateDate}`;
      this.fileLinkToStreamDownload(row.url, title, "pdf");
    },
    /**
     * 文件链接转文件流下载--主要针对pdf 解决谷歌浏览器a标签下载pdf直接打开的问题
     * @param url  ：文件链接
     * @param fileName  ：文件名;
     * @param type  ：文件类型;
     */
    fileLinkToStreamDownload (url, fileName, type) {
      let _this = this;
      let xhr = new XMLHttpRequest();
      xhr.open("get", url, true);
      xhr.setRequestHeader("Content-Type", `application/${type}`);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (this.status == 200) {
          //接受二进制文件流
          var blob = this.response;
          _this.downloadExportFile(blob, fileName, type);
        }
      };
      xhr.send();
    },
    /**
     *下载导出文件
     * @param blob  ：返回数据的blob对象或链接
     * @param tagFileName  ：下载后文件名标记
     * @param fileType  ：文件类 word(docx) excel(xlsx) ppt等
     */
    downloadExportFile (blob, tagFileName, fileType) {
      let downloadElement = document.createElement("a");
      let href = blob;
      if (typeof blob == "string") {
        downloadElement.target = "_blank";
      } else {
        href = window.URL.createObjectURL(blob); //创建下载的链接
      }
      downloadElement.href = href;
      downloadElement.download = tagFileName + "." + fileType; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      if (typeof blob != "string") {
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }
    },
    //去详情
    goExperimentDetail () {
      if (this.$route.path == "/myExperiment") {
        this.$router.push(`/experimentListDetail?id=${this.id}`);
      }
    },
    getTime (date) {
      return util.getTime(date);
    },
    //查看成绩
    queryScore () {
      this.dialogTableVisible = true;
      this.$api.experiment.getMyReport(this.experimentDetail.id).then((res) => {
        if (res.errCode == 0) {
          this.scoreList = res.data;
        }
      });
    },
    getExperimentInfo () {
      if (this.isRoles == 1) {
        //教师
        this.$api.experiment.queryExperiment(this.id).then((res) => {
          if (res.errCode == 0) {
            this.experimentDetail = res.data;
            this.loading = true;
            this.num += 1;
            if (this.num == 1) {
              this.isCollection = false;
            }
          }
        });
      } else {
        //学生
        this.$api.experiment.getExperimentInfo(this.id).then((res) => {
          if (res.errCode == 0) {
            this.experimentDetail = res.data;
            this.loading = true;
            this.num += 1;
            if (this.num == 1) {
              this.isCollection =
                this.experimentDetail.isFavor == 1 ? true : false;
            }
          }
        });
      }
    },
    //是否收藏
    Collection () {
      this.isCollection = !this.isCollection;
      if (this.isCollection) {
        this.$api.experiment.collect(this.experimentDetail.id).then((res) => {
          if (res.errCode == 0) {
            this.$message({
              message: "收藏成功",
              type: "success",
            });
            this.getExperimentInfo(); //刷新一下数据
          }
        });
      } else {
        this.$api.experiment
          .cancelCollect(this.experimentDetail.id)
          .then((res) => {
            if (res.errCode == 0) {
              this.$message({
                message: "取消收藏成功",
                type: "success",
              });
              this.getExperimentInfo(); //刷新一下数据
              if (this.$route.path == "/myExperiment") {
                this.$emit("getMyExperiment", 0);
              }
            }
          });
      }
    },
    //退出选课
    quitSelfStudy () {
      this.$api.experiment
        .quitSelfStudy(this.experimentDetail.id)
        .then((res) => {
          if (res.errCode == 0) {
            this.$message({
              message: "退出选课成功",
              type: "success",
            });
            this.getExperimentInfo();
            if (this.$route.path == "/myExperiment") {
              this.$emit("getMyExperiment", 0);
            }
          }
        });
    },
    //开始实验
    play () {
      if (this.$route.path == "/myExperiment") {
        this.$router.push(`/experimentListDetail?id=${this.id}`);
        return;
      }
      this.$emit("startExperiment");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .operation {
  text-align: center;
  color: #409eff;

  i {
    font-style: normal;
    margin: 0 15px;
    color: #99a7c3;
  }

  span {
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #1880fa;
  }
}

.el-dialog__wrapper /deep/ .el-dialog__title {
  font-size: 16px;
  font-family: PingFang-SC;
  font-weight: 400;
  line-height: 20px;
  color: #909399;
}

.playContent {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;

  .cover {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.5;
  }

  .play {
    width: 1550px;
    height: 850px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

    .close {
      position: absolute;
      top: -20px;
      right: -20px;
      font-size: 20px;
      color: #fff;
      cursor: pointer;
    }
  }
}

.experimentListDetail-top {
  display: flex;
  justify-content: start;

  .experimentListDetail-top-title {
    padding-top: 8px;

    .startExperiment {
      display: flex;
      justify-content: start;

      .btn1,
      .btn2,
      .btn3,
      .btn4 {
        width: 112px;
        height: 42px;
        background: #1880fa;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 42px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
        margin-right: 16px;
      }

      .btn2,
      .btn3,
      .btn4 {
        background: #fff;
        border: 1px solid #1880fa;
        color: #1880fa;
        box-sizing: border-box;
      }
    }

    .logo-list {
      display: flex;
      justify-content: start;
      margin: 24px 0 43px 0;

      .list {
        span {
          font-size: 13px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 18px;
          color: #747f8f;
          opacity: 1;
          margin-left: 5px;
        }
      }

      .line {
        width: 0px;
        height: 16px;
        border: 1px solid #dfe3eb;
        opacity: 1;
        margin: 0 18px;
      }
    }

    .isOpen {
      display: flex;
      justify-content: start;
      align-items: center;

      .open {
        width: 42px;
        height: 21px;
        border: 1px solid #1880fa;
        box-sizing: border-box;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 19px;
        color: #1880fa;
        margin-right: 8px;
        text-align: center;
      }

      span {
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #747f8f;
      }
    }

    h3 {
      display: flex;
      justify-content: start;
      align-items: center;

      span {
        font-size: 16px;
        font-family: PingFang-SC;
        font-weight: 500;
        line-height: 22px;
        color: #424346;
      }

      i {
        display: inline-block;
        width: 46px;
        height: 22px;
        border: 1px solid #ff9f3e;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 22px;
        color: #ff9f3e;
        font-style: normal;
        text-align: center;
        margin-left: 13px;
      }
    }

    h4 {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #747f8f;
      opacity: 1;
      margin: 13px 0 11px 0;
    }
  }

  .logo {
    width: 383px;
    height: 230px;
    margin-right: 20px;
  }
}

.fontSizeCenter {
  display: inline-block;
  width: 100%;
  text-align: center;
}
</style>
